import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-dialog-show-pagos',
  templateUrl: './dialog-show-pagos.component.html',
  styleUrls: ['./dialog-show-pagos.component.css']
})
export class DialogShowPagosComponent implements OnInit {
  listaPagos= [];

  DataSource = new MatTableDataSource<any>([]);
  DisplayedColumns: string[] = ['monto', 'igv'];

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<DialogShowPagosComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
      this.listaPagos = data.lista;
     }

     ngOnInit(): void {
      this.DataSource.data = this.listaPagos;
    }

    close(): void {
      this.dialogRef.close({ event: 'Cancel' });
    }

}
